
export function StyleCTA({ unit }) {

    if(unit.project) {
        return(
            <a href={ unit.project.permalink } className="button">
              See Details
            </a>
          );
    }
    return;
}